import { CommonSearchParams } from '@api/common/types';

import { APIClient } from '..';
import { CUSTOMER_PROFILE_KEY } from './customers';
import { FAVORITE_KEY } from './favorites';

const COMPARE_URL = 'customers/compared-offers';
const FAVORITE_URL = 'customers/favorite-offers';
const CUSTOMER_PROFILE_URL = 'lk/profile';

export const COMPARE_KEY = 'compared';

export const getComparedOffers = (apiClient: APIClient) => (data: CommonSearchParams<Record<string, string>>) => ({
    key: [COMPARE_KEY, data],
    fetch: () =>
        apiClient.post(`${COMPARE_URL}:search`, {
            data,
        }),
});

export const getFavoriteOffers = (apiClient: APIClient) => (data: CommonSearchParams<Record<string, string>>) => ({
    key: [FAVORITE_KEY, data],
    fetch: () =>
        apiClient.post(`${FAVORITE_URL}:search`, {
            data,
        }),
});

export const getCustomerProfile = (apiClient: APIClient) => (include?: string[]) => ({
    key: CUSTOMER_PROFILE_KEY,
    fetch: () => apiClient.get(CUSTOMER_PROFILE_URL, include?.length ? { params: { include } } : undefined),
});
